import CareerPage from '../modules/career/pages/CareerPage';

import withViewEvent from '../modules/common/utils/tracking/withViewEvent';
import { K_AMPLITUDE_EVENT_VIEW_CAREER_PAGE } from '../modules/common/libs/amplitude/events';

export default withViewEvent(CareerPage, K_AMPLITUDE_EVENT_VIEW_CAREER_PAGE);
